define(function(require) {

  const IpsModelCollection = require('civicsBase/ipsModelCollection');
  return IpsModelCollection.extend({
    url: '/delegate/civics-api/api/core/codedescriptions/Hansen.Resources.NotificationMethod',
    parse:function(r){
        _.each(r.data.codeDescriptionItems, function (codeDescript) {
            if( codeDescript.description == null || codeDescript.description.trim().length <= 0 ){
                  codeDescript.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
            }
        });
      return r.data.codeDescriptionItems;
    }
  });
});
